import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';

@Component({
  selector: 'app-redirect-cloudbox',
  templateUrl: './redirect-cloudbox.component.html',
  styleUrls: ['./redirect-cloudbox.component.css']
})
export class RedirectCloudboxComponent implements OnInit {

  constructor(private gallery: GalleryService,
    private route: ActivatedRoute,
    private router: Router,
    private logger: LoggerService) { }

  ngOnInit(): void {
    this.activate();
  }

  activate() {
    try {
      var fileId = this.route.snapshot.params['fileid'];
      var fileName = this.route.snapshot.params['filename'];
      var fileExtension = this.route.snapshot.params['fileextension'];
      var token = this.route.snapshot.params['token'];

      this.gallery.doCloudBoxLoginAction('fetchfile',
        'file_id=' + encodeURIComponent(fileId) +
        '&file_name=' + encodeURIComponent(fileName) +
        '&file_extension=' + encodeURIComponent(fileExtension) +
        '&token=' + encodeURIComponent(token)
      ).then(
        data => {
          try {
            if (data['url']) {
              this.router.navigate([data['url']], {});
            } else {
              console.log('BOX: Got invalid response.', data);
              this.logger.write2log('redirect-cloudbox-dologin.2', 'Got invalid response.', 'E');

              this.router.navigate(["/gallery/"], {});
            }
          } catch (e) {
            this.logger.write2log('redirect-cloudbox-dologin.3', e.message, 'E');

            this.router.navigate(["/gallery/"], {});
          }
        });

    } catch (e) {
      this.logger.write2log('redirect-cloudbox-dologin', e.message, 'E');
    }
  }

}
